export const SEARCH_JOBS_REQUEST = 'gustav/jobs/search/SEARCH_REQUEST';
export const SEARCH_JOBS_SUCCESS = 'gustav/jobs/search/SEARCH_SUCCESS';
export const SEARCH_JOBS_ERROR = 'gustav/jobs/search/SEARCH_ERROR';

export const FETCH_BULLHORN_JOB_REQUEST = 'gustav/jobs/fetch/FETCH_REQUEST';
export const FETCH_BULLHORN_JOB_SUCCESS = 'gustav/jobs/fetch/FETCH_SUCCESS';
export const FETCH_BULLHORN_JOB_ERROR = 'gustav/jobs/fetch/FETCH_ERROR';

export const FETCH_BULLHORN_JOB_PREFILL_REQUEST =
  'gustav/jobs/prefill/FETCH_REQUEST';
export const FETCH_BULLHORN_JOB_PREFILL_SUCCESS =
  'gustav/jobs/prefill/FETCH_SUCCESS';
export const FETCH_BULLHORN_JOB_PREFILL_ERROR =
  'gustav/jobs/prefill/FETCH_ERROR';

export const CANDIDATES_BULLHORN_JOB_SUBMISSIONS_CREATE_REQUEST =
  'gustav/candidates/jobSubmission/CREATE_REQUEST';
export const CANDIDATES_BULLHORN_JOB_SUBMISSIONS_CREATE_SUCCESS =
  'gustav/candidates/jobSubmission/CREATE_SUCCESS';
export const CANDIDATES_BULLHORN_JOB_SUBMISSIONS_CREATE_ERROR =
  'gustav/candidates/jobSubmission/CREATE_ERROR';

export const CANDIDATES_BULLHORN_JOB_SUBMISSIONS_SEARCH_REQUEST =
  'gustav/candidates/jobSubmission/SEARCH_REQUEST';
export const CANDIDATES_BULLHORN_JOB_SUBMISSIONS_SEARCH_SUCCESS =
  'gustav/candidates/jobSubmission/SEARCH_SUCCESS';
export const CANDIDATES_BULLHORN_JOB_SUBMISSIONS_SEARCH_ERROR =
  'gustav/candidates/jobSubmission/SEARCH_ERROR';

export const CANDIDATES_BULLHORN_BULK_JOB_SUBMISSIONS_CREATE_REQUEST =
  'gustav/candidates/bulkJobSubmissions/CREATE_REQUEST';
export const CANDIDATES_BULLHORN_BULK_JOB_SUBMISSIONS_CREATE_SUCCESS =
  'gustav/candidates/bulkJobSubmissions/CREATE_SUCCESS';
export const CANDIDATES_BULLHORN_BULK_JOB_SUBMISSIONS_CREATE_ERROR =
  'gustav/candidates/bulkJobSubmissions/CREATE_ERROR';

export const CREATE_CANDIDATE_SEARCH_FROM_BULLHORN_JOB_REQUEST =
  'gustav/candidates/searches/CREATE_FROM_BULLHORN_JOB_REQUEST';
export const CREATE_CANDIDATE_SEARCH_FROM_BULLHORN_JOB_SUCCESS =
  'gustav/candidates/searches/CREATE_FROM_BULLHORN_JOB_SUCCESS';
export const CREATE_CANDIDATE_SEARCH_FROM_BULLHORN_JOB_ERROR =
  'gustav/candidates/searches/CREATE_FROM_BULLHORN_JOB_ERROR';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_SEARCH_REQUEST =
  'gustav/candidates/tearSheets/SEARCH_REQUEST';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_SEARCH_SUCCESS =
  'gustav/candidates/tearSheets/SEARCH_SUCCESS';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_SEARCH_ERROR =
  'gustav/candidates/tearSheets/SEARCH_ERROR';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_ADD_CANDIDATE_REQUEST =
  'gustav/candidates/tearSheets/ADD_CANDIDATE_REQUEST';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_ADD_CANDIDATE_SUCCESS =
  'gustav/candidates/tearSheets/ADD_CANDIDATE_SUCCESS';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_ADD_CANDIDATE_ERROR =
  'gustav/candidates/tearSheets/ADD_CANDIDATE_ERROR';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_CREATE_REQUEST =
  'gustav/candidates/tearSheets/CREATE_REQUEST';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_CREATE_SUCCESS =
  'gustav/candidates/tearSheets/CREATE_SUCCESS';
export const CANDIDATES_BULLHORN_TEAR_SHEETS_CREATE_ERROR =
  'gustav/candidates/tearSheets/CREATE_ERROR';
export const BULLHORN_FIELD_OPTIONS_REQUEST =
  'gustav/integrations/bullhorn/FIELD_OPTIONS_REQUEST';
export const BULLHORN_FIELD_OPTIONS_SUCCESS =
  'gustav/integrations/bullhorn/FIELD_OPTIONS_SUCCESS';
export const BULLHORN_FIELD_OPTIONS_ERROR =
  'gustav/integrations/bullhorn/FIELD_OPTIONS_ERROR';
export const BULLHORN_CORPORATE_USERS_REQUEST =
  'gustav/integrations/bullhorn/CORPORATE_USERS_REQUEST';
export const BULLHORN_CORPORATE_USERS_SUCCESS =
  'gustav/integrations/bullhorn/CORPORATE_USERS_SUCCESS';
export const BULLHORN_CORPORATE_USERS_ERROR =
  'gustav/integrations/bullhorn/CORPORATE_USERS_ERROR';
